import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getDashboardData = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/dashboard');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
